import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-view-fallback',
  templateUrl: './mobile-view-fallback.component.html',
  styleUrls: ['./mobile-view-fallback.component.scss']
})
export class MobileViewFallbackComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
